import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { EditMediaRequest } from '@nucleus-commerce/api-client/admin';

import { mediaApi } from '../api/media-api';

import { mediaKeys } from './media-keys';

export interface UseEditMediaOptions {
  /** Extra query keys to refresh, e.g. a product gallery that embeds the media row. */
  invalidates?: ReadonlyArray<readonly unknown[]>;
}

export function useEditMedia({ invalidates = [] }: UseEditMediaOptions = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: EditMediaRequest }) => mediaApi.edit(id, body),
    meta: { successMessage: 'media:toasts.edited', invalidates },
    onSuccess: (media) => {
      queryClient.setQueryData(mediaKeys.detail(media.id), media);
      return queryClient.invalidateQueries({ queryKey: mediaKeys.lists() });
    },
  });
}

export function useRevertMedia({ invalidates = [] }: UseEditMediaOptions = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => mediaApi.revert(id),
    meta: { successMessage: 'media:toasts.reverted', invalidates },
    onSuccess: (media) => {
      queryClient.setQueryData(mediaKeys.detail(media.id), media);
      return queryClient.invalidateQueries({ queryKey: mediaKeys.lists() });
    },
  });
}
